import React from "react";
import "./App.css";
import Login from "./components/login";
import SignUp from "./components/signup";
import Password from "./components/forgot_password";
import { Routes, Route } from "react-router-dom";
import Dashboard from "./components/dashboard";
import Queries from "./components/Queries";
import ViewResponse from "./components/view_response";
import QueryDetails from "./components/QueryDetails";
import Settings from "./components/dashboard_settings";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Layout from "./components/layout";
import { Toaster } from "react-hot-toast";
import { UserProvider } from "./context/UserContext";
import AdminLogin from "./admin-ui/admin-login";
import AdminDashboard from "./admin-ui/dashboard";
import QueryManagement from "./admin-ui/query -managment";

const App: React.FC = () => {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <UserProvider>
        <Layout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/password" element={<Password />} />
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/queries" element={<Queries />} />
            <Route path="/view_response" element={<ViewResponse />} />
            <Route path="/query_details" element={<QueryDetails />} />
            <Route path="/settings" element={<Settings />} />
            {/* admin routes */}
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route
              path="/admin-queries-management"
              element={<QueryManagement />}
            />
          </Routes>
        </Layout>
      </UserProvider>
    </>
  );
};

export default App;
